<template>
    <CRUDDialog
      ref="crudDialog"
      :baseCrudKey="baseCrudKey"
      :canSave="false"
      :tabsList="tabsList"
      >
      <!-- @upsertItem="onPickListSave"
      @deleteItem="onPickListDelete" -->
      <template v-slot:[`editedItem`]="{}">
    <v-tabs-items v-model="tabsInit">
      <v-card-text v-if="tabsInit === 0">
        <PickListTab :baseCrudKey="baseCrudKey" @refetchTaxInquiryData="refetchTaxInquiryData" />
      </v-card-text>
      <v-card-text v-if="tabsInit === 1">
        <ProtestTaxPaymentsTab :baseCrudKey="baseCrudKey"/>
      </v-card-text>
    </v-tabs-items>
    </template>
    <!-- <template v-slot:[`additionalActionsAfterDelete`]="{}">
      <v-btn v-if="tabsInit === 0" class="input-text-size" text color="error darken-1"
        @click="onPickListDelete()">Delete</v-btn>
    </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn v-if="tabsInit === 0" class="input-text-size" text color="blue darken-1"
        @click="onPickListSave()">Save</v-btn>
    </template> -->
    </CRUDDialog>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import { pickListAndProtestTaxPaymentsTabs } from '../TaxInquiryUtils/TaxInquiry.utils';
import PickListTab from './PickListTab.vue';
import ProtestTaxPaymentsTab from './ProtestTaxPaymentsTab.vue';

export default {
  name: 'ProtestAndPickListTabs',
  components: {
    CRUDDialog,
    PickListTab,
    ProtestTaxPaymentsTab,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'ProtestAndPickListTabs',
    },
  },
  data: () => ({
    tabVal: 0,
    tabsList: [...pickListAndProtestTaxPaymentsTabs],
    pickListCriteriaBaseCrudKey: 'pickListCriteria',
  }),
  computed: {
    ...mapGetters('base/crud', [
      'selectedTab', 'item', 'items', 'isVisible', 'criteria',
    ]),
    tabsInit: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setSelectedTab',
      'setIsVisible',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    ...mapActions('tax/taxInquiryTabs', [
      'loadTabsAdjustments',
      // 'upsertPickListProfileNames',
      // 'deletePickListBasedOnProfileName',
    ]),
    refetchTaxInquiryData() {
      this.$emit('refetchTaxInquiryData');
    },
    // async onPickListDelete() {
    //   const pickListCriteria = this.criteria(this.pickListCriteriaBaseCrudKey);
    //   if (pickListCriteria.profileName) {
    //     const item = { profileName: pickListCriteria.profileName };
    //     await this.deletePickListBasedOnProfileName(
    //       { item, baseCrudKey: this.pickListBaseCrudKey },
    //     );
    //     this.setIsVisible([this.baseCrudKey, false]);
    //   } else {
    //     this.custumColrFlashMsg({ msg: 'Please select a Profile Name' });
    //   }
    // },
    // async onPickListSave() {
    //   const pickListCriteria = this.criteria(this.pickListCriteriaBaseCrudKey);
    //   if (pickListCriteria.profileName) {
    //     const itemData = this.items('pickListTable');
    //     const listOfIds = (itemData || []).map((ft) => ft._id);
    //     const item = { listOfIds, profileName: pickListCriteria.profileName };
    //     await this.upsertPickListProfileNames({ item });
    //     this.setIsVisible([this.baseCrudKey, false]);
    //   } else {
    //     this.custumColrFlashMsg({ msg: 'Please select a Profile Name' });
    //   }
    // },
  },
};
</script>
